import { render } from "./MenuParametros.vue?vue&type=template&id=0ae20b2a"
import script from "./MenuParametros.vue?vue&type=script&lang=js"
export * from "./MenuParametros.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__